export default (state, videoObj) => {
    state.latestVideo = videoObj
}
